module.exports = __webpack_public_path__ + "img/ar-sa.6a315025.svg";